import React from "react";
import { useColors } from "../constants/Colors";

interface TagProps {
  icon?: React.ReactNode;
  variant?: "default" | "accent";
  label: string;
}

const Tag: React.FC<TagProps> = ({ icon, variant = "default", label }) => {
  const {
    containerTertiarySolidLow,
    containerNeutralLightMedium,
    accentColor,
    textNeutralDefault,
  } = useColors();
  const borderColor =
    variant === "accent" ? accentColor : containerNeutralLightMedium;
  const bgColor =
    variant === "accent" ? containerTertiarySolidLow : "transparent";
  const textColor = variant === "accent" ? accentColor : textNeutralDefault;

  return (
    <div
      className="
          rounded-full px-3 py-1.5 
          text-xs sm:text-sm 
          flex items-center gap-1.5
        "
      style={{
        border: `1px solid ${borderColor}`,
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      {icon && <span className="inline-block text-[10px]">{icon}</span>}
      <span>{label}</span>
    </div>
  );
};

export default Tag;
